import React from 'react'
import { useHistory } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { Button, Form } from 'lib/ui'
import { useCheckout, useCheckoutContext } from 'lib/modules/checkout'

export const ShippingStepActions = () => {
  const history = useHistory()
  const { state } = useCheckoutContext()
  const {
    shippingMethod,
    shippingAddress,
    validateShippingAddress,
    validateShippingMethod,
    validateEmail
  } = useCheckout()

  const hasErrors = Object.keys({ ...state.emailErrors, ...state.shippingErrors }).length
  const hasValidShippingAddress = validateShippingAddress()
  const hasValidShippingMethod = validateShippingMethod()
  const hasValidEmail = validateEmail()
  const isValid = hasValidShippingAddress && hasValidShippingMethod && hasValidEmail

  return (
    <Form.Actions.Wrapper autoArrangeWidth={false}>
      <div>
        <Button
          type='button'
          isDisabled={hasErrors || !isValid}
          isLoading={shippingMethod.isFetching || shippingAddress.isFetching}
          onClick={() => { history.push('/checkout/billing') }}
        >
          <FormattedMessage
            id='checkout.shipping.action.submit'
          />
        </Button>
      </div>
    </Form.Actions.Wrapper>
  )
}
